import { all, takeEvery, put, call, select, debounce } from "redux-saga/effects";
import { searchParams, sortParams } from "common/helpers/query";
import { notification } from "components/ui";
import { selectedCompanySelector, companyIdSelector } from "modules/account/selectors/accountSelector";
import * as companyDataContext from "common/dataProvider/company";

import * as action from "../actions/transactionListAction";
import * as selector from "../selectors/transactionListSelector";

export function* initKkmTransactionListSaga() {
	try {
		const company = yield select(selectedCompanySelector);
		const companyId = yield select(companyIdSelector);

		const kkmId = yield select(selector.kkmIdSelector);
		const { size } = yield select(selector.scrollSelector);
		const { field, order } = yield select(selector.sortSelector);

		const query = { size, sort: sortParams({ field, order }) };

		const { kkm, transaction } = yield all({
			kkm: call(companyDataContext.getCompanyKkmId, { companyId, kkmId }),
			transaction: call(companyDataContext.getCompanyKkmTransaction, { companyId, kkmId, query })
		});

		yield put(
			action.initKkmTransactionList.success({
				company,
				kkm,
				items: transaction.content,
				totalElements: transaction.totalElements
			})
		);
	} catch (e) {
		yield put(action.initKkmTransactionList.error());
		notification.httpError();
	}
}

export function* scrollKkmTransactionListSaga() {
	try {
		const companyId = yield select(companyIdSelector);
		const kkmId = yield select(selector.kkmIdSelector);
		const { size, page } = yield select(selector.scrollSelector);
		const { value } = yield select(selector.searchSelector);
		const { by, start, end } = yield select(selector.filterSelector);
		const { field, order } = yield select(selector.sortSelector);

		const query = {
			size,
			page: page + 1,
			q: searchParams({ quickSearch: value, by, start, end }),
			sort: sortParams({ field, order })
		};

		const transaction = yield call(companyDataContext.getCompanyKkmTransaction, {
			companyId,
			kkmId,
			query
		});

		yield put(
			action.scrollKkmTransactionList.success({
				items: transaction.content,
				page: query.page
			})
		);
	} catch (e) {
		yield put(action.scrollKkmTransactionList.error());
		notification.httpError();
	}
}

export function* searchKkmTransactionListSaga({ payload }) {
	try {
		const { value } = payload;

		const companyId = yield select(companyIdSelector);
		const kkmId = yield select(selector.kkmIdSelector);
		const { size } = yield select(selector.scrollSelector);
		const { by, start, end } = yield select(selector.filterSelector);
		const { field, order } = yield select(selector.sortSelector);

		const query = {
			size,
			q: searchParams({ quickSearch: value, by, start, end }),
			sort: sortParams({ field, order })
		};

		const transaction = yield call(companyDataContext.getCompanyKkmTransaction, {
			companyId,
			kkmId,
			query
		});

		yield put(
			action.searchKkmTransactionList.success({
				items: transaction.content,
				totalElements: transaction.totalElements
			})
		);
	} catch (e) {
		yield put(action.searchKkmTransactionList.error());
		notification.httpError();
	}
}

export function* filterKkmTransactionListSaga() {
	try {
		const companyId = yield select(companyIdSelector);
		const kkmId = yield select(selector.kkmIdSelector);
		const { size } = yield select(selector.scrollSelector);
		const { value } = yield select(selector.searchSelector);
		const { by, start, end } = yield select(selector.filterSelector);
		const { field, order } = yield select(selector.sortSelector);

		const query = {
			size,
			q: searchParams({ quickSearch: value, by, start, end }),
			sort: sortParams({ field, order })
		};

		const transaction = yield call(companyDataContext.getCompanyKkmTransaction, {
			companyId,
			kkmId,
			query
		});

		yield put(
			action.filterKkmTransactionList.success({
				items: transaction.content,
				totalElements: transaction.totalElements
			})
		);
	} catch (e) {
		yield put(action.filterKkmTransactionList.error());
		notification.httpError();
	}
}

export function* sortKkmTransactionListSaga() {
	try {
		const companyId = yield select(companyIdSelector);
		const kkmId = yield select(selector.kkmIdSelector);
		const { size } = yield select(selector.scrollSelector);
		const { value } = yield select(selector.searchSelector);
		const { by, start, end } = yield select(selector.filterSelector);
		const { field, order } = yield select(selector.sortSelector);

		const query = {
			size,
			q: searchParams({ quickSearch: value, by, start, end }),
			sort: sortParams({ field, order })
		};

		const transaction = yield call(companyDataContext.getCompanyKkmTransaction, {
			companyId,
			kkmId,
			query
		});

		yield put(
			action.sortKkmTransactionList.success({
				items: transaction.content,
				totalElements: transaction.totalElements
			})
		);
	} catch (e) {
		yield put(action.sortKkmTransactionList.error());
		notification.httpError();
	}
}

export default function*() {
	yield all([
		takeEvery(action.initKkmTransactionList.request, initKkmTransactionListSaga),
		takeEvery(action.scrollKkmTransactionList.request, scrollKkmTransactionListSaga),
		debounce(400, action.searchKkmTransactionList.request, searchKkmTransactionListSaga),
		takeEvery(action.filterKkmTransactionList.request, filterKkmTransactionListSaga),
		takeEvery(action.sortKkmTransactionList.request, sortKkmTransactionListSaga)
	]);
}
